import { Action } from 'redux'
import { isType } from 'ts-action'
import { ITimesheetsReducer } from '@network/models/timesheet.model'
import {
  GetTimesheets,
  TimesheetsFetching,
  GetTimesheetsErrors,
} from './actions'

const initialState: ITimesheetsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const timesheetsReducer = (
  state = initialState,
  action: Action,
): ITimesheetsReducer => {
  if (isType(action, GetTimesheets)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, GetTimesheetsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, TimesheetsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
